interface Window {
    personalizationHelper?: (personalizationHelper) => void;
}

window.personalizationHelper = (personalizationOptions): object => {
    function getApiData(method, isAsync, userId) {
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.open(method, personalizationOptions.endpointUrl + "api/customer/" + userId, isAsync);
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + personalizationOptions.authorizationHeaderValue);
        try {
            xmlHttp.send();
            if (xmlHttp.status != 200) {
                return null;
            } else {
                return xmlHttp.responseText;
            }
        } catch (err) { return null; }
    };

    function getDataFromService() {
        const data = getApiData("GET", false, personalizationOptions.user);
        if (data != null) {
            const dataObj = JSON.parse(data);
            var personalizationData = {
                FirstName: dataObj.firstName,
                LastName: dataObj.lastName,
                FullName: dataObj.firstName + ' ' + dataObj.lastName,
                CompanyName: dataObj.companyName,
                Title: dataObj.jobTitle
            };
            return personalizationData;
        }
        return data;
    };

    function saveDataToLocalStorage(personalizationData) {
        return localStorage.setItem('personalization', JSON.stringify(personalizationData));
    };

    function getDataFromLocalStorage() {
        return JSON.parse(localStorage.getItem('personalization'));
    };

    function getPersonalizationData() {
        let personalizationData = getDataFromLocalStorage();

        if (personalizationData == null) {
            personalizationData = getDataFromService();
            if (personalizationData != null) {
                saveDataToLocalStorage(personalizationData);
            }
        }
        return personalizationData;
    };

    function getAutoFillParameter(data) {
        if (data == null) return '';
        let autofill = 'autofill=';
        if (data.FirstName != null) {
            autofill = autofill + 'FirstName' + '|' + encodeURI(data.FirstName) + ';';
        }
        if (data.LastName != null) {
            autofill = autofill + 'LastName' + '|' + encodeURI(data.LastName) + ';';
        }
        if (data.CompanyName != null) {
            autofill = autofill + 'CompanyName' + '|' + encodeURI(data.CompanyName) + ';';
        }
        if (data.Title != null) {
            autofill = autofill + 'JobTitle' + '|' + encodeURI(data.Title) + ';';
        }
        return autofill.slice(0, -1);
    }

    return {
        personalizedImageUrl: function (imageUrl): string {
            const personalizedData = getPersonalizationData();
            if (!personalizedData) { return imageUrl; }
            if (!imageUrl.includes(personalizationOptions.renderServerUrl)) {
                var urlList = imageUrl.split('/');
                var origin = urlList[0] + '//' + urlList[2] + '/';
                imageUrl = imageUrl.replace(origin, personalizationOptions.renderServerUrl);
            }
            if (imageUrl.charAt(imageUrl.length - 1) === ';') {
                imageUrl = imageUrl.slice(0, -1);
            }
            imageUrl = imageUrl + '&' + getAutoFillParameter(personalizedData);
            return imageUrl;
        }
    };
};
